// extracted by mini-css-extract-plugin
module.exports = {"container":"AddImage_container__2AgcM","text":"AddImage_text__3bwg-","plus":"AddImage_plus__3AsTu"};